import { app } from '../app';

app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor($state,ConstantAlert,$rootScope) {

    return {request,response};

    function request(config) {
    
        if (config.data) {
            delete config.data.$promise;
            delete config.data.$resolved;
        }
        return config;
    }
    function response(response) {
    	
    	if($state.$current.includes['company'] === true){
    		if(response.config.url.indexOf('app/rest/admin/company/') > -1 || response.config.url.indexOf('app/rest/v2/company/') > -1 ||response.config.url.indexOf('app/rest/company/') > -1){
    			var afterCompany=response.config.url.split('company/')[1];
    			var companyId=afterCompany.split('/')[0];
    			var isnum = /^\d+$/.test(companyId);
    			if(isnum){
    				var alertVariables={};
    				var autocloseAlert=false;
    				var spLicenseViolation=response.headers('SP-lisense-violation');
    				if(spLicenseViolation == null  ){
    					alertVariables={closeNow:true};
    					autocloseAlert=true;
    					ConstantAlert('','', alertVariables, autocloseAlert);
    					//console.log('closingg alert');
    				} else {
    					//console.log('opening alert');
    					var message="company.license.violation.alert_message."+spLicenseViolation;
    					ConstantAlert('danger',message, alertVariables, autocloseAlert,true,'company.license.violation.details','license-violation');
    				}
    			}
    		}
    	}
    	return response;
    }
}



// WEBPACK FOOTER //
// ./src/portal/config/resource-interceptor.config.js